/**
 * Toast context for sharing toast state between provider and hook.
 */

import { createContext } from 'react';

/** An optional action button rendered inside a toast (e.g. "Undo"). */
export interface ToastAction {
  label: string;
  onClick: () => void;
}

export interface ToastContextValue {
  showToast: (
    message: string,
    variant?: 'success' | 'warning' | 'error',
    options?: { action?: ToastAction },
  ) => void;
}

/** How long a toast stays up, and so how long its action (Undo) can be pressed. */
export const TOAST_DISMISS_MS = 4000;

export const ToastContext = createContext<ToastContextValue | null>(null);
